import H from './com/h';
import Yoga from './com/Yoga';
import Group from './com/group1';
import Group2 from './com/group2';
import Group3 from './com/group3';
import Group5 from './com/group5';
import Group6 from './com/group6';
import Group7 from './com/group7';
import Group8 from './com/group8';
import Footer from './com/footer';

export default function App() {
  return (
    <div>
      <H></H>
      <Yoga></Yoga>
      <Group></Group>
      <Group2></Group2>
      <Group3></Group3>
      <Group5></Group5>
      <Group6></Group6>
      <Group7></Group7>
      <Group8></Group8>
      {/* <div className='h-96 bg-black'></div> */}
      <Footer></Footer>
    </div>
  );
}
